// regionReform.js — 행정구역 개편 매핑 (2026-09-01 신설, 프론트 미러)
//   백엔드 정본: api/services/tm/region-reform.js — 상수·로직 동일, 수정 시 양쪽 함께.
//   상황판 extractRegion 등 프론트에서 주소를 직접 파싱하는 곳의 그룹핑 정합용.

const GEOMDAN_DONGS = ['마전동', '금곡동', '오류동', '왕길동', '당하동', '원당동', '대곡동', '불로동', '백석동', '시천동'];
const YEONGJONG_DONGS = ['중산동', '운남동', '운서동', '운북동', '을왕동', '남북동', '덕교동', '무의동'];
const BUCHEON_WONMI = ['원미동', '심곡동', '춘의동', '도당동', '약대동', '중동', '상동', '소사동', '역곡동'];
const BUCHEON_SOSA = ['심곡본동', '소사본동', '송내동', '괴안동', '범박동', '옥길동', '계수동'];
const BUCHEON_OJEONG = ['오정동', '원종동', '고강동', '작동', '여월동', '삼정동', '내동', '대장동'];
const HWASEONG_DONGTAN = ['반송동', '석우동', '능동', '청계동', '영천동', '오산동', '여울동', '장지동', '송동', '방교동', '산척동', '목동', '신동'];
const HWASEONG_BYEONGJEOM = ['병점동', '진안동', '기산동', '반월동', '황계동', '배양동', '기안동'];

function buildDongMap(entries) {
  const map = new Map();
  for (const [dongs, target] of entries) {
    for (const d of dongs) map.set(d, target);
  }
  return map;
}

const REFORM_RULES = {
  '인천 서구': { default: '인천 서해구', byDong: buildDongMap([[GEOMDAN_DONGS, '인천 검단구']]) },
  '인천 동구': { default: '인천 제물포구' },
  '인천 중구': { default: '인천 제물포구', byDong: buildDongMap([[YEONGJONG_DONGS, '인천 영종구']]) },
  '군위군': { default: '대구 군위군' },
  '부천': {
    default: '부천',
    byDong: buildDongMap([
      [BUCHEON_WONMI, '부천 원미구'], [BUCHEON_SOSA, '부천 소사구'], [BUCHEON_OJEONG, '부천 오정구'],
    ]),
  },
  '화성': {
    default: '화성',
    byDong: buildDongMap([
      [HWASEONG_DONGTAN, '화성 동탄구'], [HWASEONG_BYEONGJEOM, '화성 병점구'],
    ]),
    // 도로명 주소 보조 판별: 동탄지성로·동탄대로 등 '동탄' 접두 도로는 전부 동탄구
    byPrefix: [['동탄', '화성 동탄구']],
  },
};

/** 파싱된 지역명을 현행 행정구역 명칭으로 정규화 (tokens = 주소 토큰, 법정동 탐색용) */
export function applyRegionReform(region, tokens = []) {
  const rule = REFORM_RULES[region];
  if (!rule) return region;
  if (rule.byDong) {
    for (const t of tokens) {
      // "당하동1097-12"처럼 번지가 붙은 토큰도 매칭되게 끝의 숫자·하이픈 제거
      const key = String(t).replace(/\d[\d-]*$/, '');
      const hit = rule.byDong.get(key) || rule.byDong.get(t);
      if (hit) return hit;
    }
  }
  if (rule.byPrefix) {
    for (const t of tokens) {
      for (const [prefix, target] of rule.byPrefix) {
        if (String(t).startsWith(prefix)) return target;
      }
    }
  }
  return rule.default;
}
